import React, { Component } from 'react'
import SimpleTabs from './components/CreateOrderTabPanel';

class CreateOrderTab extends Component {
    render() {
        return (
            <div>
              <SimpleTabs />
            </div>
        )
    }
}
  
export default CreateOrderTab
  